import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { QuestionVoucherI18nBase } from "./base/root";

export const VoucherI18nFormMain = () => {
	return (
		<FeatureIslandMainWithBackGround>
			<QuestionVoucherI18nBase />
		</FeatureIslandMainWithBackGround>
	);
};

VoucherI18nFormMain.displayName = "VoucherI18nFormMain";
